export const AWSStateConfigurationTabs = [
  { name: "All", Bordercolor: "#2f0de0", BackgroundColor: "#2f0de0" ,Color:"Black" },
  { name: "Uncategorized", Bordercolor: "#808080", BackgroundColor: "#dcdcdc" ,Color:"Black" },
  { name: "Active", Bordercolor: "#008000", BackgroundColor: "#e9ffdb" ,Color:"Black" },
  { name: "Inactive", Bordercolor: "#FF0000", BackgroundColor: "#f5e4e4" ,Color:"Black" },
  { name: "Transitioning", Bordercolor: "#FFA500", BackgroundColor: "#f5e8d0" ,Color:"Black" },
];

export const PolicyCategorizationTabs = [
    { name: "All", Bordercolor: "#2f0de0" , BackgroundColor:"#2f0de0" , Color:"Black" } ,
    { name: "Uncategorized", Bordercolor: "#3FA7D6" , BackgroundColor:"#edf2f5" , Color:"Black" } ,
    { name: "High", Bordercolor: "#FF0000" , BackgroundColor:"#f5e4e4" , Color:"Black" },
    { name: "Medium", Bordercolor: "#FFA500" , BackgroundColor:"#f5e8d0" , Color:"Black" },
    { name: "Low", Bordercolor: "#FFE500" , BackgroundColor:"#f7f7c8" , Color:"Black" }
];

 


